import { ProductDetailsModule } from '@/modules/product/product-details';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  id: z.coerce.string(),
});

export const Route = createFileRoute('/dashboard/product/$id')({
  params: {
    parse: params => paramsSchema.parse(params),
    stringify: params => ({ id: String(params.id) }),
  },
  component: ProductDetailsPage,
});

function ProductDetailsPage() {
  return <ProductDetailsModule />;
}
